
export default function NotAloneSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Você Não Está Sozinho(a)
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A suspeita de <strong>infidelidade conjugal</strong> é uma das experiências mais dolorosas que alguém pode enfrentar. 
            Você não está imaginando coisas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <img 
              src="https://readdy.ai/api/search-image?query=Compassionate%20counselor%20or%20therapist%20in%20professional%20office%20setting%2C%20warm%20lighting%2C%20person%20showing%20empathy%20and%20understanding%2C%20modern%20office%20with%20comfortable%20seating%2C%20professional%20yet%20welcoming%20atmosphere%2C%20high%20quality%20photography&width=600&height=400&seq=empathy-img&orientation=landscape"
              alt="Suporte profissional e empático"
              className="rounded-lg shadow-lg w-full object-cover object-top"
            />
          </div>
          
          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-bar-chart-line text-red-600 text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900">Dados Reais</h3>
              </div>
              <p className="text-gray-700">
                <strong>1.200 divórcios por ano</strong> no Brasil têm a infidelidade como principal causa. 
                Sua suspeita pode estar fundamentada.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-heart-pulse-line text-red-600 text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900">Validação da Sua Dor</h3>
              </div>
              <p className="text-gray-700">
                A <strong>ansiedade, insônia e angústia</strong> que você sente são reações normais. 
                Não é paranoia - é seu instinto te alertando.
              </p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-lightbulb-line text-green-600 text-xl"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900">Você Pode Estar Errado</h3>
              </div>
              <p className="text-gray-700">
                E isso seria <strong>maravilhoso</strong>. Nossa investigação também serve para 
                <strong> tranquilizar</strong> e fortalecer relacionamentos saudáveis.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
